import { Center, Container, Loader } from "@mantine/core";
import { useState } from "react";

export const FeedbackView = () => {
  const [loading, setLoading] = useState(true);
  return (
    <Container h={"100%"} size="xl" mt="xl">
      {loading && (
        <Center w="100%" h="100%">
          <Loader size="xl" />
        </Center>
      )}
      <iframe
        src="https://www.surveymonkey.ca/r/PK87CT7"
        title="survey"
        frameBorder="no"
        width={"100%"}
        height={"100%"}
        allowTransparency={true}
        allowFullScreen={true}
        onLoad={() => setLoading(false)}
      ></iframe>
    </Container>
  );
};
